<script>
import { api } from "@/state/services";

export default {
  locales: {
    pt: {
      'Evolution Plan': 'Plano de Evolução',
      'Cumulative discount on all graduations': 'Desconto cumulativo em todas as graduações',
      'Become VIP': 'Seja VIP',
      'Become Ambassador': 'Seja Embaixador',
      'Become Diamond': 'Seja Diamond',
    },
    es: {
      'Evolution Plan': 'Plan de Evolución',
      'Cumulative discount on all graduations': 'Descuento acumulativo en todas las graduaciones',
      'Become VIP': 'Sé VIP',
      'Become Ambassador': 'Sé Embajador',
      'Become Diamond': 'Sé Diamond',
    }
  },
  data() {
    return {
      tracks: [],
    };
  },
  methods: {
    getEvolucao() {
      api
        .get('reports/evolucao')
        .then(response => {
          if (response.data.status == 'success' && Array.isArray(response.data.tracks)) {
            this.tracks = response.data.tracks
          }
        })
    },
    // Divide o título traduzido na primeira palavra e no restante (duas linhas no mobile)
    titleParts(label) {
      const words = this.t(label).split(' ')
      return { first: words.shift(), rest: words.join(' ') }
    },
    // Conector fica colorido apenas quando o nível atual e o próximo foram conquistados
    isLinked(track, index) {
      const next = track.levels[index + 1]
      return !!next && track.levels[index].status == 'achieved' && next.status == 'achieved'
    },
  },
  mounted() {
    this.getEvolucao()
  },
};
</script>

<template>
  <fieldset v-if="tracks.length" class="p-0 evo-compact">
    <legend>{{ t('Evolution Plan') }}</legend>
    <div class="evo-compact__grid">
      <div v-for="track in tracks" :key="track.key" class="evo-card" :class="'evo-card--' + track.variant">
        <div class="evo-card__head">
          <div class="evo-card__icon"><i :class="['bx', track.icon]"></i></div>
          <h6 class="evo-card__title">
            <span class="evo-card__title-line">{{ titleParts(track.label).first }}</span>
            <span class="evo-card__title-line">{{ titleParts(track.label).rest }}</span>
          </h6>
        </div>
        <ul class="evo-levels">
          <li
            v-for="(level, index) in track.levels"
            :key="level.name"
            class="evo-level"
            :class="['evo-level--' + level.status, { 'evo-level--linked': isLinked(track, index) }]"
          >
            <span class="evo-level__node">
              <i v-if="level.status == 'achieved'" class="bx bx-check"></i>
              <i v-else-if="level.status == 'locked'" class="bx bxs-hourglass-top"></i>
              <span v-else class="evo-level__dot"></span>
            </span>
            <span class="evo-level__name">{{ level.name }}</span>
          </li>
        </ul>
      </div>
    </div>
  </fieldset>
</template>

<style scoped>
.evo-compact__grid {
  display: flex;
  gap: 8px;
  align-items: stretch;
  padding: 0 10px;
}
.evo-card {
  --evo-color: #0f9d58;
  flex: 1 1 0;
  min-width: 0;
  border-radius: 8px;
  padding: 16px 8px 0px;
  text-align: center;
}
.evo-card--green { --evo-color: #0f9d58; }
.evo-card--amber { --evo-color: #e6a417; }
.evo-card--indigo { --evo-color: #1F74A8; }

.evo-card__head {
  background-color: #F2F2F7;
  border-radius: 10px;
  padding: 10px 10px 5px;

}
.evo-card__icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 8px;
  border-radius: 50%;
  background: var(--evo-color);
  color: #fff;
  font-size: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.evo-card__title-line { display: block; }
.evo-card__title {
  font-weight: 500;
}

.evo-levels {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}
.evo-level {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 56px;
  font-size: 12px;
  text-align: left;
}
/* Conector vertical (mobile) */
.evo-level:not(:last-child)::before {
  content: "";
  position: absolute;
  left: 13px;
  top: 28px;
  bottom: -28px;
  width: 2px;
  background: #d9dce0;
}
.evo-level--linked::before { background: var(--evo-color) !important; }

.evo-level__node {
  position: relative;
  z-index: 1;
  flex: 0 0 28px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #c5c9cf;
  background: #fff;
  color: #adb5bd;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}
.evo-level--achieved .evo-level__node {
  background: var(--evo-color);
  border-color: var(--evo-color);
  color: #fff;
}
.evo-level--progress .evo-level__node { border-color: var(--evo-color); }
.evo-level__dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--evo-color);
}

@media (min-width: 768px) {
  .evo-compact__grid { gap: 16px; }
  .evo-card { padding: 16px; }
  .evo-card__head {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    margin-bottom: 16px;
    padding-bottom: 10px;
  }
  .evo-card__icon { width: 56px; height: 56px; margin: 0; font-size: 28px; flex: 0 0 56px; }
  .evo-card__title-line { display: inline; }
  .evo-card__title-line + .evo-card__title-line::before { content: " "; }
  .evo-card__title { border-bottom: 0; padding-bottom: 0; margin: 0; text-align: left; }
  .evo-levels { flex-direction: row; }
  .evo-level {
    flex: 1 1 0;
    flex-direction: column;
    min-height: 0;
    gap: 6px;
    text-align: center;
  }
  /* Conector horizontal (desktop) */
  .evo-level:not(:last-child)::before {
    left: 50%;
    right: -50%;
    top: 13px;
    bottom: auto;
    width: auto;
    height: 2px;
  }
}

/* Tablet: nomes dos níveis inclinados para manter o espaçamento entre eles */
@media (min-width: 768px) and (max-width: 1199px) {
  .evo-levels { padding-bottom: 52px; }
  .evo-level__name {
    position: absolute;
    top: 34px;
    right: 50%;
    white-space: nowrap;
    transform: rotate(-40deg);
    transform-origin: right top;
  }
}
</style>
